const initialState = {
  ldapList: [],
};

const ldapManagement = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_LDAP_LIST": {
      const ldapList = action.payload;

      return { ...state, ldapList };
    }
    default:
      return state;
  }
};

export default ldapManagement;
